import { render, staticRenderFns } from "./SSelectLang.vue?vue&type=template&id=ad570bfa&scoped=true"
import script from "./sSelectLang.ts?vue&type=script&lang=ts&external"
export * from "./sSelectLang.ts?vue&type=script&lang=ts&external"
import style0 from "./SSelectLang.vue?vue&type=style&index=0&id=ad570bfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad570bfa",
  null
  
)

export default component.exports